<template>
  <div class="app-main-inner">
    <el-dialog
      :visible.sync="visible"
      :title="$t('ChangeCharge.details')"
      width="1300px"
      :close-on-click-modal="false"
      :show-close="false"
      class="before-and-after-comparison"
      top="10vh"
      :append-to-body="appendToBody"
      @open="showDialog"
    >
      <div style="margin-bottom: -30px;display: flex">
        <div style="text-align: right;width: 20%">
          <el-checkbox v-model="showCharge">{{ $t('CargoMsg.Cargo_HideUnmodifiedFees') }}</el-checkbox>
        </div>
        <div v-if="tips" style="text-align: right; width: 70%">
          <span> {{ $t('CargoMsg.Cargo_ChargeChangeTip') }} </span>
        </div>
      </div>
      <el-tabs :active-name="activeTabName" @tab-click="handleClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_Receivable')" name="receivable" class="app-main-content">
          <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
            <el-form :inline="true" label-width="60px" label-position="right">
              <span style="font-size: 13px;font-weight: bold;">{{ $t('ChangeCharge.modifyBefore') }}</span>
            </el-form>
          </div>
          <div id="vsPage1" class="app-main-inner-row row-grid" style="height: 220px; padding: 0;">
            <cargo-ag-grid
              key="chargeGrid1"
              config-module="202409"
              :grid-params.sync="receivable.chargeBeforeGrid.gridParams"
              :grid-options="receivable.chargeBeforeGrid.gridOptions"
              :column-defs="chargeBeforeGridColumnDefs"
              :row-data="chargeBeforeRowDataReceivable"
              :show-side-bar="true"
              :auto-fit-content="false"
              min-height="250"
              style="height:220px;width: 100%;"
            />
          </div>
          <div
            style="display: flex; justify-content: flex-end; padding-right: 10px; padding-top: 8px;height: 30px; background-color: #f5f7f7;"
          >
            <span style="font-size: 13px;" v-text="$t('ChangeCharge.estimateProfit')" />
            <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
              <div style="display: flex;">
                <div v-for="(item,index) in chargeOriginalProfit" :key="index">
                  <change-charge-count-item-renderer :item="item" />
                </div>
              </div>
            </div>
          </div>
          <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
            <el-form :inline="true" label-width="60px" label-position="right">
              <span style="font-size: 13px;font-weight: bold;">{{ $t('ChangeCharge.modifyAfter') }}</span>
            </el-form>
          </div>
          <div class="app-main-inner-row row-grid" style="height: 220px; padding: 0;">
            <cargo-ag-grid
              key="chargeGrid2"
              config-module="202408"
              :grid-params.sync="receivable.chargeAfterGrid.gridParams"
              :grid-options="receivable.chargeAfterGrid.gridOptions"
              :column-defs="arChargeAfterGridColumnDefs"
              :row-data="chargeAfterRowDataReceivable"
              :auto-fit-content="false"
              min-height="250"
              style="height:220px;width: 100%;"
            />
          </div>
          <div
            style="display: flex; justify-content: flex-end; padding-right: 10px; padding-top: 8px; height: 30px; background-color: #f5f7f7;"
          >
            <span style="font-size: 13px;" v-text="$t('ChangeCharge.estimateProfit')" />
            <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
              <div style="display: flex;">
                <div v-for="(item,index) in chargeChangeProfit" :key="index">
                  <change-charge-count-item-renderer :item="item" />
                </div>
                <span>
                  {{ arTip }}
                </span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_Dues')" name="payable" class="app-main-content">
          <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
            <el-form :inline="true" label-width="60px" label-position="right">
              <span style="font-size: 13px;font-weight: bold;">{{ $t('ChangeCharge.modifyBefore') }}</span>
            </el-form>
          </div>
          <div class="app-main-inner-row row-grid" style="height: 220px; padding: 0;">
            <cargo-ag-grid
              key="chargeGrid1"
              config-module="202407"
              :grid-params.sync="payable.chargeBeforeGrid.gridParams"
              :grid-options="payable.chargeBeforeGrid.gridOptions"
              :column-defs="chargeBeforeGridColumnDefs"
              :row-data="chargeBeforeRowDataPayable"
              :auto-fit-content="false"
              min-height="250"
              style="height:220px;width: 100%;"
            />
          </div>
          <div
            style="display: flex; justify-content: flex-end; padding-right: 10px; padding-top: 8px; height: 30px; background-color: #f5f7f7;"
          >
            <span style="font-size: 13px;" v-text="$t('ChangeCharge.estimateProfit')" />
            <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
              <div style="display: flex;">
                <div v-for="(item,index) in chargeOriginalProfit" :key="index">
                  <change-charge-count-item-renderer :item="item" />
                </div>
              </div>
            </div>
          </div>
          <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
            <el-form :inline="true" label-width="60px" label-position="right">
              <span style="font-size: 13px;font-weight: bold;">{{ $t('ChangeCharge.modifyAfter') }}</span>
            </el-form>
          </div>
          <div class="app-main-inner-row row-grid" style="height: 220px; padding: 0;">
            <cargo-ag-grid
              key="chargeGrid2"
              config-module="202406"
              :grid-params.sync="payable.chargeAfterGrid.gridParams"
              :grid-options="payable.chargeAfterGrid.gridOptions"
              :column-defs="apChargeAfterGridColumnDefs"
              :row-data="chargeAfterRowDataPayable"
              :auto-fit-content="false"
              min-height="250"
              style="height:220px;width: 100%;"
            />
          </div>
          <div
            style="display: flex; justify-content: flex-end; padding-right: 10px; padding-top: 8px; height: 30px; background-color: #f5f7f7;"
          >
            <span style="font-size: 13px;" v-text="$t('ChangeCharge.estimateProfit')" />
            <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
              <div style="display: flex;">
                <div v-for="(item,index) in chargeChangeProfit" :key="index">
                  <change-charge-count-item-renderer :item="item" />
                </div>
                <span>
                  {{ apTip }}
                </span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!--      <div style="display: flex; margin: 2px;">-->
      <!--        <el-form label-position="left" label-width="80px" style="width: 1100px;">-->
      <!--          <el-col :span="24">-->
      <!--            <el-form-item :label="$t('ChangeCharge.changeReason')">-->
      <!--              <el-input v-model="changeReason" :disabled="true" type="textarea" :rows="3" resize="none" no="1" />-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <!--        </el-form>-->
      <!--      </div>-->
      <div slot="footer">
        <span>
          <el-button type="primary" no="2" @click="cancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ChangeChargeCountItemRenderer from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/changeChargeCountItemRenderer'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'

export default {
  name: 'BeforeAndAfterComparisonDialogBpm',
  components: { ChangeChargeCountItemRenderer },
  props: {
    visible: { type: Boolean, required: true },
    appendToBody: { type: Boolean, required: false, default: false },
    apTip: { type: String, required: false, default: '' },
    arTip: { type: String, required: false, default: '' },
    tips: { type: Boolean, default: true },
    changeReason: { type: String, default: '' }, // 更改原因
    arChargeBefore: { type: Array, default: () => [] }, // 修改前
    apChargeBefore: { type: Array, default: () => [] }, // 修改前
    arChargeAfter: { type: Array, default: () => [] }, // 修改后
    apChargeAfter: { type: Array, default: () => [] }, // 修改后
    chargeOriginalProfit: { type: Array, default: () => [] }, // 整票预估利润：修改前
    chargeChangeProfit: { type: Array, default: () => [] } // 整票预估利润：修改后
  },
  data() {
    return {
      receivable: { // 应收
        chargeBeforeGrid: {
          rowData: [],
          gridParams: {},
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressClipboardPaste: true,
            suppressRowClickSelection: false,
            context: {
              componentParent: this
            },
            defaultColDef: {
              // sortable: false,
              // resizable: false,
              // menuTabs: []
            }
          }
        },
        chargeAfterGrid: {
          rowData: [],
          gridParams: {},
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressClipboardPaste: true,
            suppressRowClickSelection: false,
            context: {
              componentParent: this
            },
            defaultColDef: {
              // sortable: false,
              // resizable: false,
              // menuTabs: []
            }
          }
        }
      },
      payable: { // 应付
        chargeBeforeGrid: {
          rowData: [],
          gridParams: {},
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressClipboardPaste: true,
            suppressRowClickSelection: false,
            context: {
              componentParent: this
            },
            defaultColDef: {
              // sortable: false,
              // resizable: false,
              // menuTabs: []
            }
          }
        },
        chargeAfterGrid: {
          rowData: [],
          gridParams: {},
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressClipboardPaste: true,
            suppressRowClickSelection: false,
            context: {
              componentParent: this
            },
            defaultColDef: {
              // sortable: false,
              // resizable: false,
              // menuTabs: []
            }
          }
        }
      },
      showCharge: false, // 隐藏未改动费用
      activeTabName: 'receivable', // 应收
      redCellStyle: { color: 'red' }
    }
  },
  computed: {
    chargeBeforeGridColumnDefs() {
      console.log('chargeBeforeGridColumnDefs')
      const result = [
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_settleAccountsTo'), field: 'accountId', width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140 },
        { headerName: this.$t('FinanceManage.charge_somesticOrInternational'), field: 'oversea', width: 60,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        { headerName: this.$t('FinanceManage.charge_drawABillOrNot'), field: 'needInvoice', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        { headerName: this.$t('Payment.controlledOrNot'), field: 'controlled', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        { headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 60 },
        { headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 60,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.adChargeInfo_quantity'), field: 'quantity', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        { headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), field: 'amount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxExcludedPrice'), field: 'excludingTaxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxAmount'), field: 'taxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate', colId: 'accountingDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('FinanceManage.charge_contactPerson'), field: 'contactPerson', width: 60 },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 140 },
        { headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180 },
        { headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_CostNumber'), field: 'originalSerialNo', width: 140 }
      ]
      if (this.$store.getters.currentOffice.whtTaxMode) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        })
      }
      return result
    },
    // chargeAfterGridColumnDefs() {
    //
    // },
    arChargeAfterGridColumnDefs() {
      return this.chargeAfterGridColumnDefs(true)
    },
    apChargeAfterGridColumnDefs() {
      return this.chargeAfterGridColumnDefs(false)
    },
    // 应收修改前
    chargeBeforeRowDataReceivable() {
      this.checkField(this.arChargeBefore, this.arChargeAfter)
      if (this.showCharge) {
        return this.arChargeBefore.filter(p => p.checkRed)
      } else {
        return this.arChargeBefore
      }
    },
    // 应收修改后
    chargeAfterRowDataReceivable() {
      if (this.showCharge) {
        return this.arChargeAfter.filter(p => p.checkRed || p.actionType === 1)
      } else {
        return this.arChargeAfter
      }
    },
    // 应付修改前
    chargeBeforeRowDataPayable() {
      this.checkField(this.apChargeBefore, this.apChargeAfter)
      if (this.showCharge) {
        return this.apChargeBefore.filter(p => p.checkRed)
      } else {
        return this.apChargeBefore
      }
    },
    // 应付修改后
    chargeAfterRowDataPayable() {
      if (this.showCharge) {
        return this.apChargeAfter.filter(p => p.checkRed || p.actionType === 1)
      } else {
        return this.apChargeAfter
      }
    },
    chargeBeforeRowData() {
      return this.chargeBefore
    },
    chargeAfterRowData() {
      return this.chargeAfter
    }
  },
  methods: {
    showDialog() {
      console.log('showDialog:')
      this.receivable.chargeBeforeGrid.gridOptions.api.clearFocusedCell()
      this.receivable.chargeAfterGrid.gridOptions.api.clearFocusedCell()
      this.payable.chargeBeforeGrid.gridOptions.api.clearFocusedCell()
      this.payable.chargeAfterGrid.gridOptions.api.clearFocusedCell()
    },
    handleClick(tab, event) {
      this.activeTabName = tab.name
    },
    checkField(list1, list2) {
      const stringFields = ['contactPerson', 'currency', 'oversea', 'needInvoice', 'measure', 'remarks',
        'relatedMbl', 'relationContainerNo']
      const fields = ['chargeItemId', 'accountId', 'exchangeRate', 'quantity', 'unitRate', 'amount',
        'excludingTaxAmount', 'taxRate', 'taxAmount', 'whtTaxRate', 'whtTaxAmount', 'whtTaxLocalAmount']
      // 计算下是否有费用发生改变，并打上标记
      for (const data of list2) {
        let update = fields.some(field => ColumnUtils.fieldCellStyle2(list1, list2, {
          colDef: { field },
          data: data
        }, true))
        if (!update) {
          update = stringFields.some(field => ColumnUtils.fieldCellStyle2(list1, list2, {
            colDef: { field },
            data: data
          }, false))
        }
        data.checkRed = update
      }

      // 原费用也打上标记
      for (const dataCb of list1) {
        const matchingData = list2.find(dataAf => dataCb.originalSerialNo === dataAf.originalSerialNo)
        if (matchingData) {
          dataCb.checkRed = matchingData.checkRed
        }
      }
    },
    chargeAfterGridColumnDefs(ar) {
      console.log('chargeAfterGridColumnDefs')
      const result = [
        { headerName: this.$t('ChangeCharge.actionType'), field: 'actionType',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.value)
          }, width: 90 },
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_settleAccountsTo'), field: 'accountId', width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_somesticOrInternational'), field: 'oversea', width: 60,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_drawABillOrNot'), field: 'needInvoice', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('Payment.controlledOrNot'), field: 'controlled', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 60,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 60,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.adChargeInfo_quantity'), field: 'quantity', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        { headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), field: 'amount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxExcludedPrice'), field: 'excludingTaxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxAmount'), field: 'taxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        {
          headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate', colId: 'accountingDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('FinanceManage.charge_contactPerson'), field: 'contactPerson', width: 60,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 140 },
        { headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OriginalExpenseNumber'), field: 'originalSerialNo', width: 140 }
      ]
      if (this.$store.getters.currentOffice.whtTaxMode) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          },
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          cellStyle: (params) => {
            const d = ColumnUtils.fieldCellStyle(this.arChargeBefore, this.arChargeAfter, this.apChargeBefore, this.apChargeAfter, ar, params)
            return d ? this.redCellStyle : null
          },
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        })
      }
      return result
    },
    cancel() {
      this.$emit('onCancel')
    }
  }
}
</script>

<style lang="scss">
.before-and-after-comparison {
  .el-dialog__body {
    padding: 2px !important;
    .el-form-item {
      margin-bottom: 0!important;
    }
  }
  .ag-theme-balham {
    .ag-cell{
      user-select: text;
    }
  }
  .redStyle {
    color: red;
  }
}
</style>
